import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import { SearchService, getAuthToken } from '../../service';

import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import FlagIcon from '@mui/icons-material/Flag';
import SouthAmericaIcon from '@mui/icons-material/SouthAmerica';
import regionService from '../../service/region.service';
import countryService from '../../service/country.service';
import stateService from '../../service/state.service';
import portService from '../../service/port.service';

const MapSearch = ({ OnPinSelect }) => {
    const { instance, accounts } = useMsal();

    // Autocomplete
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [optionValue, setOptionValue] = useState();

    // Selected Option
    useEffect(() => {
        (async () => {
            if (!optionValue) return;

            await getOptionPin();
        })();
    }, [optionValue]);

    const getOptionPin = async () => {
        const authToken = await getAuthToken(instance, accounts);

        if (optionValue.MatchResultType === 'Region') {
            const pin = await regionService.getById(authToken, optionValue.MatchResultTypeId);
            OnPinSelect(pin, 'region');
        } else if (optionValue.MatchResultType === 'Country') {
            const pin = await countryService.getById(authToken, optionValue.MatchResultTypeId);
            OnPinSelect(pin, 'country');
        } else if (optionValue.MatchResultType === 'State') {
            const pin = await stateService.getById(authToken, optionValue.MatchResultTypeId);
            OnPinSelect(pin, 'state');
        } else if (optionValue.MatchResultType === 'Port') {
            const pin = await portService.getById(authToken, optionValue.MatchResultTypeId);
            OnPinSelect(pin, 'port');
        }
    };

    const getLookupData = async (query) => {
        let data = [];

        const authToken = await getAuthToken(instance, accounts);
        const searchResult = await SearchService.fuzzy(authToken, query);

        if (searchResult) {
            searchResult.map((item) => {
                data.push(item);
            });
        }

        setOptions(data);
    };

    const handleInputChange = async (_, value) => {
        if (value.length > 2) {
            await getLookupData(value);
        }
    };

    /** override default autocomplete filter logic since filter is done through the api */
    const filterOptions = (item) => {
        return item;
    };

    /** override default autocomplete isOptionEqualToValue logic since filter is done through the api */
    const isOptionEqualToValue = (option, value) => {
        return true;
    };

    const valueOnChange = (event, value) => {
        setOptionValue(value);
        setOptions([]);
    };

    const getOptionName = (option) => {
        if (!option) return '';

        if (option.MatchResultType === 'Region') return option.Region;
        else if (option.MatchResultType === 'Country') return option.Country;
        else if (option.MatchResultType === 'State') return option.State;
        else if (option.MatchResultType === 'Port') return option.Port;

        return '';
    };

    return (
        <Autocomplete
            sx={{
                width: '300px',
                background: '#FFFFFF',
                borderRadius: '8px',
                border: 'none',
                boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px'
            }}
            popupIcon={null}
            onChange={valueOnChange}
            isOptionEqualToValue={isOptionEqualToValue}
            filterOptions={filterOptions}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => {
                // setOptionValue();
                // setOptions([]);
                // OnPinSelect(null, null);
                setOpen(false);
            }}
            options={options}
            getOptionLabel={(option) => getOptionName(option)}
            size="small"
            onInputChange={handleInputChange}
            renderInput={(params) => <TextField {...params} placeholder="Port, State, Country, Region" fullWidth />}
            renderOption={(props, option) => {
                return (
                    <>
                        <Box component="li" key={option._id} sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                            {option.MatchResultType === 'Region' && <SouthAmericaIcon sx={{ height: '18px' }} />}
                            {option.MatchResultType === 'Country' && <FlagIcon sx={{ height: '18px' }} />}
                            {option.MatchResultType === 'State' && <AccountBalanceIcon sx={{ height: '18px' }} />}
                            {option.MatchResultType === 'Port' && <DirectionsBoatIcon sx={{ height: '18px' }} />}

                            <Typography>
                                {option.MatchResultType === 'Region' && <>{option.Region}</>}
                                {option.MatchResultType === 'Country' && (
                                    <>
                                        {option.Country}
                                        <Typography variant="caption" display="block">
                                            {option.Region}
                                        </Typography>
                                    </>
                                )}
                                {option.MatchResultType === 'State' && (
                                    <>
                                        {option.State}
                                        <Typography variant="caption" display="block">
                                            {`${option.Country}, ${option.Region}`}
                                        </Typography>
                                    </>
                                )}
                                {option.MatchResultType === 'Port' && (
                                    <>
                                        {option.Port}
                                        <Typography variant="caption" display="block">
                                            {option.State != '' && <>{`${option.State}, `}</>}
                                            {`${option.Country}, ${option.Region}`}
                                        </Typography>
                                    </>
                                )}
                            </Typography>
                        </Box>
                    </>
                );
            }}
        />
    );
};

export default MapSearch;
